import React, {ReactNode} from "react";


import parseHTML from "html-react-parser";


import { Col } from "react-bootstrap";


import "./index.scss";


import { CardTypesType } from "@Components/Elements";


type CardMainDescriptionComponentProps = {
    children: ReactNode | ReactNode[];
    cardType?: CardTypesType;
    size?: 's' | 'md' | 'lg';
};


export const CardMainDescriptionComponent:React.FC<CardMainDescriptionComponentProps> = ({
    children, cardType = 'default', size = 'md'
}) => {

    if (!children) {
        return null;
    }

    return (
        <Col xs={12} className={`card-component__main-description ${cardType}-card-component__main-description card-component__main-description--${size}`}>
            {children}
        </Col>
    );

};


export default CardMainDescriptionComponent;
